exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".integrations-view{background:#fff;padding:22px}.integrations-view_items{margin-top:22px;width:650px}", "", {"version":3,"sources":["/divvit-app/client/views/IntegrationsView/client/views/IntegrationsView/style.styl","/divvit-app/client/views/IntegrationsView/style.styl"],"names":[],"mappings":"AAAA,mBACE,gBAAA,YACA,CAEA,yBACE,gBAAA,WACA,CCCH","file":"style.styl","sourcesContent":[".integrations-view\n  background: white\n  padding: gutter-width\n\n  &_items\n    margin-top: 22px\n    width: 650px\n",".integrations-view {\n  background: #fff;\n  padding: 22px;\n}\n.integrations-view_items {\n  margin-top: 22px;\n  width: 650px;\n}\n/*# sourceMappingURL=client/views/IntegrationsView/style.css.map */"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--3-1!./node_modules/postcss-loader/lib??postcss!./node_modules/stylus-loader??ref--3-3!./client/views/IntegrationsView/style.styl
// module id = 649
// module chunks = 0